// extracted by mini-css-extract-plugin
module.exports = {"start_Game":"StartGame_start_Game__1YYL2"};